import React from 'react';
import { connect } from 'react-redux'
import { Modal, Button } from 'react-bootstrap'
import moment from 'moment'
import { PropTypes } from 'prop-types'
import { getLabel } from "../../language"
import { Link } from 'react-router-dom';
import Avatar from '../../images/avatar.svg'
import agent from "../../agent"
import { fetchPage } from "../../actions/page"
import { createSingleVote, fetchVotesList } from "../../actions/votes"
import { fetchFollowings, onFollow, onUnFollow } from "../../actions/following";
import Slider from "react-rangeslider";
import VoterLocationsTab from "../Settings/VoterLocationsTab";
import Loader from "../Loader";
import { Modal as antdModel} from 'antd';

const mapStateToProps = state => ({
    page: state.page,
    votes: state.votes.votes,
    currentUser: state.common.currentUser,
    isAuthorized: state.auth && state.auth.isAuthorized,
});

const mapDispatchToProps = dispatch => ({
    onFollow: dispatch(onFollow),
    onUnFollow: dispatch(onUnFollow),
    fetchFollowings: dispatch(fetchFollowings),
    fetchPageData: (slug) => dispatch(fetchPage(slug)),
    createSingleVote: dispatch(createSingleVote),
    fetchVotesList: dispatch(fetchVotesList),

});

class PostShowModel extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            viewMyVotes: this.props.voteItem && this.props.voteItem.viewMyVotes > 0 ? (parseInt(this.props.voteItem.viewMyVotes) === 1 ? 2 : this.props.voteItem.viewMyVotes) : this.props.currentUser && this.props.currentUser.viewMyVotes,
            viewMyVotesDefault: '',
            prevVote: { personId: '', ability: 0, vision: 0, dateCreated: '' },
            curVote: { personId: this.props.userData.personID, ability: 0, vision: 0 },
            currentUser: this.props.currentUser,
            isFollowing: false,
            privacyModal: false,
            selectedAudience: true,
            followLevel: '',
            voteItem: '',
            watchHover: '',
            watchCloselyHover: '',
            commentList: [],
            isWatch: 1,
            isWatchClosely: 2,
            followeeType: 'P',
            polliesComment: '',
            downVote: 0,
            upVote: 0,
            mayBe: 0,
            vote: '',
            isVoted: '',
            isLoding: true,
            isFinal: false,
        };

        this.handleOnChange = this.handleOnChange.bind(this);
        this.onChange = this.onChange.bind(this)
    }

    componentWillMount() {
        const { personID, urlSlug } = this.props.userData
        this.props.fetchPageData(urlSlug);
        if (personID) {
            this.props.fetchVotesList(personID)
            agent.Pollies.getAveragesVotes(personID).then(res => {
                if (res) {
                    this.setState({
                        downVote: res.votesAgainst || 0,
                        upVote: res.votesFor || 0,
                        mayBe: res.votesUnspecified || 0,
                    })
                }
            }, err => {
                console.log(err.message)
            })
        }

        agent.UserLocations.get().then((res) => {
            if (res && Array.isArray(res) && res.length > 0) {
                let selectedLoc = res[0].id;
                this.setState({
                    voterLocation: selectedLoc,
                    voterLocationName: res[0].country,
                    isLoding: false
                })
            } else {
                console.log('locaions doesn\'t exists')
                this.setState({
                    isLoding: false
                })
            }
        })
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.page && nextProps.page.page) {
            this.setState({
                ...nextProps.page.page
            })
        }
        if (nextProps.userData.personID && nextProps.votes && Array.isArray(nextProps.votes)) {
            const voteItem = this.getVotesById(nextProps.userData.personID, nextProps.votes);
            this.setState({
                prevVote: voteItem,
                polliesComment: voteItem && voteItem.comment,
                vote: voteItem && voteItem.vote,
                isVoted: voteItem && voteItem.dateCreated,
                isFinal: voteItem && voteItem.isFinal
            })
        }

        if (this.props && this.props.currentUser) {
            this.props.fetchFollowings(this.props.currentUser && this.props.currentUser.id)
            this.setState({
                viewMyVotes: this.props.currentUser ? (parseInt(this.props.currentUser && this.props.currentUser.viewMyVotes) === 1 ? 2 : this.props.currentUser && this.props.currentUser.viewMyVotes) : null,
                viewMyVotesDefault: this.props.currentUser ? this.props.currentUser.viewMyVotes : null,
            })
        }
    }

    openModal = () => {
        this.setState({ isOpen: !this.state.isOpen })
    }

    getVotesById = (personID, votes) => {
        if (personID && votes) {
            return votes.find(item => item.personID === personID && moment(item.dateCreated).isBetween(moment().startOf('day'), moment().endOf('day')));
        }
    }

    onMouseOver = (e) => {
        if (e.target && e.target.id === 'watch') {
            this.setState({
                watchHover: true,
            })
        } else if (e.target && e.target.id === 'watchClosely') {
            this.setState({
                watchCloselyHover: true,
            })
        }
    }

    onMouseOut = (e) => {
        if (e.target && e.target.id === 'watch') {
            this.setState({
                watchHover: false,
            })
        }
        else if (e.target && e.target.id === 'watchClosely') {
            this.setState({
                watchCloselyHover: false,
            })
        }
    }

    onUnFollow = () => {
        this.props.onUnFollow(this.props.userData.personID, this.state.followeeType);
        this.setState({
            followLevel: 0
        })
    }

    onWatchClick = (ev) => {
        ev.preventDefault();
        this.watch(this.state.isWatch)
    }

    onWatchCloselyClick = (ev) => {
        ev.preventDefault();
        this.watch(this.state.isWatchClosely)
    }

    watch = (followLevel) => {
        this.props.onFollow(this.props.userData.personID, this.props.userData.personID, this.state.followeeType, followLevel);
        this.setState({
            followLevel: followLevel
        })
    }

    handleOnChange = (e, field) => {
        this.setState({ ...this.state, curVote: { ...this.state.curVote, [field]: e } });
    }

    onLikeSubmit = (e) => {
        let vote = ''
        if (e.target.name === "downVote") {
            vote = 'A'
        } else if (e.target.name === "upVote") {
            vote = 'F'
        } else if (e.target.name === "mayBe") {
            vote = 'U'
        }
        this.setState({ vote })
    }

    onChange = (e) => {
        const state = this.state;
        if (e.target.name === "polliesComment" || e.target.name === "isFinal") {
            state[e.target.name] = e.target.type === 'checkbox' ? e.target.checked : e.target.value
        } else {
            state[e.target.name] = parseInt(e.target.value);
        }
        this.setState(state);
    }

    onVoteSubmit = () => {
        if(this.state.vote !== '' && this.state.vote !== undefined){
            const curVote = this.state.curVote;
            curVote.viewMyVotes = this.state.viewMyVotes || 0;
            curVote.viewMyVotesDefault = this.state.viewMyVotesDefault || 0;
            curVote.polliesComment = this.state.polliesComment;
            curVote.vote = this.state.vote;
            curVote.isFinal = this.state.isFinal;
            this.props.createSingleVote({ ...curVote }, this.props.userData.personID);
            this.setState({ ...this.state, curVote: { ...curVote } });
            this.props.openModel()
        }else{
            antdModel.warning({
                title: getLabel(333),
                zIndex: 5000
            });
        }
    }

    getYesterDayVotesById = (personID, votes) => {
        if (personID && votes) {
            return votes.find(item => item.personID === personID && moment(item.dateCreated).isBetween(moment().add(-1, 'days').startOf('day'), moment().add(-1, 'days').endOf('day')));
        }
    }

    render() {
        if (!this.props.page || !this.props.page.page) return null
        const { displayName, photoName, lastOfficeTitle, personID, urlSlug, lastOfficeCountryName } = this.props.page.page
        const { downVote, upVote, mayBe, vote, polliesComment, followLevel, watchHover, watchCloselyHover,
            isVoted, voterLocation, voterLocationName, isLoding, isFinal, } = this.state
        const { vision, ability } = this.state.curVote
        let disable = "disabled";
        const id = `remember-${this.state.personId}`;
        let yesterdayVoteId = this.getYesterDayVotesById(this.props.userData.personID, this.props.votes)
        return (
            <>
                <Modal
                    show={this.props.isOpen}
                    bsSize="large"
                    className="polly-modal vote-popup"
                    aria-labelledby="contained-modal-title-lg"
                    onHide={this.props.openModel}>
                    {
                        isLoding ? <div>{<Loader/>}</div> :
                            voterLocation ?
                                <div id="votepopup">
                                    <div className="modal-header">
                                        <div className="row">
                                            <div className="col-md-12">
                                                <h3 className="pollname mb-3">
                                                    {displayName}<span>{lastOfficeTitle}, {lastOfficeCountryName}</span>
                                                </h3>
                                            </div>
                                        </div>
                                        <button type="button"
                                            className="close"
                                            onClick={this.props.openModel}
                                            data-dismiss="modal"
                                            aria-label="Close">
                                            <span aria-hidden="true">×</span>
                                        </button>
                                    </div>
                                    <div className="modal-body">
                                        <div className="row">
                                            <div className="col-md-12">
                                                <div className="mainpolinfo">
                                                    <div className="polthumb">
                                                        <img onError={e => e.target.src = Avatar}
                                                            src={photoName ? `/images/people/${personID}/official/${photoName}` : Avatar}
                                                            alt="user-img" />
                                                    </div>
                                                    {
                                                        yesterdayVoteId &&
                                                        <div className="polscores">
                                                            <label>{getLabel(234)}</label>
                                                            <div className="row">
                                                                <div className="thumbvote d-flex flex-row justify-content-between">
                                                                    <div className={`${yesterdayVoteId.vote && "isDisabled"} col-md-12 thumbvote d-flex flex-row`}>
                                                                        <a className="pointer"
                                                                            id={"maybe"}>{mayBe}%</a>
                                                                        <a className="pointer"
                                                                            id={"downvote"}>{downVote}%</a>
                                                                        <a className="pointer"
                                                                            id={"upvote"}>{upVote}%</a>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="row">
                                                                <div className="col-md-2 vote-col-name">
                                                                    <span>{getLabel(111)}</span>
                                                                </div>
                                                                <div className="col-md-8 vision">
                                                                    <Slider
                                                                        min={1}
                                                                        max={10}
                                                                        value={yesterdayVoteId.vision}
                                                                        orientation="horizontal" />
                                                                </div>
                                                                <div className="col-md-2 vote-col-name">
                                                                    <span className="result">{yesterdayVoteId.vision}</span>
                                                                </div>
                                                            </div>

                                                            <div className="row">
                                                                <div className="col-md-2 vote-col-name">
                                                                    <span>{getLabel(110)}</span>
                                                                </div>
                                                                <div className="col-md-8 ability">
                                                                    <Slider
                                                                        min={1}
                                                                        max={10}
                                                                        value={yesterdayVoteId.ability}
                                                                        orientation="horizontal"
                                                                    />
                                                                </div>
                                                                <div className="col-md-2 vote-col-name">
                                                                    <span className="result">{yesterdayVoteId.ability}</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    }

                                                    <div className="toolbar">
                                                        <div style={{ float: "right" }}>
                                                            <button className={`btn  btn-default btn-polly-watch ${followLevel == 1 && 'active'}`}
                                                                onClick={followLevel == 1 ? this.onUnFollow : this.onWatchClick}>
                                                                <span className="polly-watching" id="watch"
                                                                    onMouseOver={this.onMouseOver}
                                                                    onMouseOut={this.onMouseOut}>{followLevel == 1 ? (watchHover ? getLabel(88) : getLabel(89)) : getLabel(90)}</span>
                                                            </button>
                                                        </div>

                                                        <div style={{ float: "right" }}>
                                                            <button className={`btn  btn-default btn-polly-watch ${followLevel == 2 && 'active'}`}
                                                                onClick={followLevel == 2 ? this.onUnFollow : this.onWatchCloselyClick}>
                                                                <span className="polly-watching" id="watchClosely"
                                                                    onMouseOver={this.onMouseOver}
                                                                    onMouseOut={this.onMouseOut}>{followLevel == 2 ? (watchCloselyHover ? getLabel(91) : getLabel(92)) : getLabel(93)}</span>
                                                            </button>
                                                        </div>
                                                        <div>

                                                            <Link to={`/${urlSlug}`} className="btn btn-info mt-1"> {getLabel(228)}</Link>

                                                        </div>
                                                    </div>
                                                    <div className="howdoyoufeel d-flex">
                                                        <h3>{this.state.prevVote && this.state.prevVote.dateCreated ? (this.state.prevVote.isFinal ? getLabel(241) : '') + getLabel(115) + (moment(this.state.prevVote.dateCreated).format('MMMM D, YYYY')) + getLabel(100) : getLabel(101)}</h3>
                                                        <textarea className="form-control commentarea"
                                                            name="polliesComment"
                                                            value={polliesComment}
                                                            disabled={isVoted && disable}
                                                            onChange={isVoted ? null : (e) => this.onChange(e)}
                                                            placeholder={getLabel(109)} />
                                                        <div className="votescore ml-2">
                                                            <div className="vote-modal">
                                                                <div className="thumbvote d-flex flex-row justify-content-between">
                                                                    <div className={`${isVoted && "isDisabled"} col-md-12 thumbvote d-flex flex-row`}>
                                                                        <a onClick={(e) => this.onLikeSubmit(e, mayBe)}
                                                                            name="mayBe"
                                                                            className="pointer"
                                                                            id={vote === "U" ? "maybe-voted" : "maybe"}>{mayBe}</a>
                                                                        <a onClick={(e) => this.onLikeSubmit(e, downVote)}
                                                                            name="downVote"
                                                                            className="pointer"
                                                                            id={vote === "A" ? "downvote-voted" : "downvote"}>{downVote}</a>
                                                                        <a onClick={(e) => this.onLikeSubmit(e, upVote)}
                                                                            name="upVote"
                                                                            className="pointer"
                                                                            id={vote === "F" ? "upvote-voted" : "upvote"}>{upVote}</a>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="row vision-line">
                                                                <div className="col-md-3 vote-col-name">
                                                                    <span>{getLabel(111)}</span>
                                                                </div>
                                                                <div className="col-md-7">
                                                                    <Slider
                                                                        className={disable || vote === 'U' ? 'disable-vote' : ''}
                                                                        min={1}
                                                                        max={10}
                                                                        step={1}
                                                                        value={isVoted ? (this.state.prevVote.vision || 0) : (vision || 0)}
                                                                        orientation="horizontal"
                                                                        disabled={disable && disable}
                                                                        onChange={isVoted || vote === 'U' ? null : (e) => this.handleOnChange(e, 'vision')}
                                                                    />
                                                                </div>
                                                                <div className="col-md-2 vote-col-name">
                                                                    <span className="result">
                                                                        {isVoted ? (this.state.prevVote.vision || 0) : (vision || 0)}
                                                                    </span>
                                                                </div>
                                                            </div>

                                                            <div className="row mt-2">
                                                                <div className="col-md-3 vote-col-name">
                                                                    <span>{getLabel(110)}</span>
                                                                </div>
                                                                <div className="col-md-7">
                                                                    <Slider
                                                                        className={disable || vote === 'U' ? 'disable-vote' : ''}
                                                                        min={1}
                                                                        max={10}
                                                                        step={1}
                                                                        value={isVoted ? (this.state.prevVote.ability || 0) : (ability || 0)}
                                                                        orientation="horizontal"
                                                                        disabled={isVoted && disable}
                                                                        onChange={isVoted || vote === 'U' ? null : (e) => this.handleOnChange(e,'ability')}
                                                                    />
                                                                </div>
                                                                <div className="col-md-2 vote-col-name">
                                                                    <span className="result">
                                                                        {isVoted ? (this.state.prevVote.ability || 0) : (ability || 0)}
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="vote-col-name">
                                                            <div className="checkboxgroup">
                                                                <input type="checkbox" id={id}
                                                                    // id="remember"
                                                                    checked={isFinal}
                                                                    disabled={!!disable}
                                                                    className="className"
                                                                    onChange={this.onChange}
                                                                    name="isFinal" />
                                                                <label htmlFor="remember">{getLabel(243)} {this.props.userData.type === "Party" ? getLabel(244) : getLabel(245)}</label>
                                                            </div>
                                                        </div>
                                                        <div>
                                                            {!(this.state.prevVote && this.state.prevVote.dateCreated) &&
                                                                <div>
                                                                    <legend>{getLabel(105)}</legend>
                                                                    <fieldset className="form-group privacy-list">
                                                                        <div className="form-check">
                                                                            <input type="radio"
                                                                                className="form-check-input"
                                                                                onChange={this.onChange}
                                                                                name="viewMyVotes"
                                                                                id="viewMyVotes2"
                                                                                value="2"
                                                                                checked={this.state.viewMyVotes === 2}
                                                                            />
                                                                            <label className="form-check-label" htmlFor="viewMyVotes2">{getLabel(72)}</label>
                                                                        </div>
                                                                        <div className="form-check">
                                                                            <input type="radio"
                                                                                className="form-check-input"
                                                                                onChange={this.onChange}
                                                                                name="viewMyVotes"
                                                                                id="viewMyVotes3"
                                                                                value="3"
                                                                                checked={this.state.viewMyVotes === 3}
                                                                            />
                                                                            <label className="form-check-label" htmlFor="viewMyVotes3">{getLabel(73)}</label>
                                                                        </div>
                                                                        <div className="form-check">
                                                                            <input type="radio"
                                                                                className="form-check-input"
                                                                                onChange={this.onChange}
                                                                                name="viewMyVotes"
                                                                                id="viewMyVotes4"
                                                                                value="4"
                                                                                checked={this.state.viewMyVotes === 4}
                                                                            />
                                                                            <label className="form-check-label" htmlFor="viewMyVotes4">{getLabel(78)}</label>
                                                                        </div>
                                                                    </fieldset>
                                                                </div>}
                                                            {/*{*/}
                                                            {/*yesterdayVoteId &&*/}
                                                            {/*<div>*/}
                                                            {/*{getLabel(114)}*/}
                                                            {/*<b>{yesterdayVoteId.vision}</b> {getLabel(110)} :<b>{yesterdayVoteId.ability}</b>*/}
                                                            {/*</div>*/}
                                                            {/*}*/}
                                                        </div>
                                                    </div>

                                                    {
                                                        !isVoted && <div className="d-flex w-100 mt-2">
                                                            <button onClick={this.onVoteSubmit}
                                                                className="btn btn-primary ml-auto"
                                                                // disabled={!vote && disable}
                                                            >{getLabel(227)}</button>
                                                        </div>
                                                    }
                                                </div>
                                                {this.state.prevVote && this.state.prevVote.dateCreated && <b>{getLabel(116)}</b>}
                                            </div>
                                        </div>
                                    </div>
                                </div> :
                                <div id="votepopup">
                                    <div className="modal-header">
                                        <div className="row">
                                            <div className="col-md-12">
                                                <h3>{getLabel(214)}</h3>
                                            </div>
                                        </div>
                                        <button type="button"
                                            className="close"
                                            onClick={this.props.openModel}
                                            data-dismiss="modal"
                                            aria-label="Close">
                                            <span aria-hidden="true">×</span>
                                        </button>
                                    </div>
                                    <div className="modal-body">
                                        <div className="row">
                                            <div className="col-md-12">
                                                <VoterLocationsTab openModel={this.props.openModel} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                    }
                </Modal>
            </>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(PostShowModel);
